function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import { TextBlock as TextBlockDSM } from './components';
const StyledTextBlock = styled(TextBlockDSM)`
  ${({
  type,
  theme
}) => {
  const typeMap = {
    default: ``,
    disclosure: `
        p {
          font-family: ${theme.textStyles[6].md.fontFamily};
          font-weight: ${theme.textStyles[6].md.fontWeight};
          font-size: ${theme.textStyles[6].md.fontSize};
          line-height: ${theme.textStyles[6].md.lineHeight};
        }
      `,
    hero: `
        && h1,
        && h2 {
          font-family: ${theme.textStyles[1].md.fontFamily};
          font-weight: ${theme.textStyles[1].md.fontWeight};
          font-size: ${theme.textStyles[1].md.fontSize};
          line-height: ${theme.textStyles[1].md.lineHeight};
          margin: ${theme.textStyles[1].md.margin};
        }
        && h3 {
          font-family: ${theme.textStyles[2].md.fontFamily};
          font-weight: ${theme.textStyles[2].md.fontWeight};
          font-size: ${theme.textStyles[2].md.fontSize};
          line-height: ${theme.textStyles[2].md.lineHeight};
          margin: ${theme.textStyles[2].md.margin};
        }
        && li,
        && p,
        && span {
          font-family: ${theme.textStyles[3].md.fontFamily};
          font-weight: ${theme.textStyles[3].md.fontWeight};
          font-size: ${theme.textStyles[3].md.fontSize};
          line-height: ${theme.textStyles[3].md.lineHeight};
        }

        @media (max-width: 900px) {
          &&& h1,
          &&& h2 {
            font-family: ${theme.textStyles[1].sm.fontFamily};
            font-weight: ${theme.textStyles[1].sm.fontWeight};
            font-size: ${theme.textStyles[1].sm.fontSize};
            line-height: ${theme.textStyles[1].sm.lineHeight};
            margin: ${theme.textStyles[1].sm.margin};
          }
          &&& h3 {
            font-family: ${theme.textStyles[2].sm.fontFamily};
            font-weight: ${theme.textStyles[2].sm.fontWeight};
            font-size: ${theme.textStyles[2].sm.fontSize};
            line-height: ${theme.textStyles[2].sm.lineHeight};
            margin: ${theme.textStyles[2].sm.margin};
          }
          &&& li,
          &&& p,
          &&& span {
            font-family: ${theme.textStyles[3].sm.fontFamily};
            font-weight: ${theme.textStyles[3].sm.fontWeight};
            font-size: ${theme.textStyles[3].sm.fontSize};
            line-height: ${theme.textStyles[3].sm.lineHeight};
          }
        }
        `
  };
  return `
      ${typeMap[type || 'default']}
      width: 100%;
      *:last-child {
      margin-bottom: 0;
    `;
}}
`;
export const TextBlock = props => {
  const {
    className
  } = props;
  return /*#__PURE__*/React.createElement(StyledTextBlock, _extends({}, props, {
    className: cn(className, 'textBlockType')
  }));
};